import { render, staticRenderFns } from "./GlobeBg.vue?vue&type=template&id=2de0a89d&scoped=true&"
import script from "./GlobeBg.vue?vue&type=script&lang=js&"
export * from "./GlobeBg.vue?vue&type=script&lang=js&"
import style0 from "./GlobeBg.vue?vue&type=style&index=0&id=2de0a89d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de0a89d",
  null
  
)

export default component.exports